export default __webpack_public_path__ + "static/media/living5.7b50f183.jpg";